import React, { ComponentType, ReactNode } from 'react'
import { css } from 'src/ui/style/css'
import { Icon } from 'src/ui/icon/Icon'
import { View } from 'src/ui/basic/View'
import { IconType } from 'react-icons'
import { useTheme } from 'src/ui/style/useTheme'

export type IconedColor = 'primary' | 'tertiary' | 'black'

export type IconedProps = {
    icon: IconType
    children?: ReactNode
    color?: IconedColor | false
    iconRight?: boolean
    wrap?: boolean
}

export const Iconed: ComponentType<IconedProps> = ({
    icon,
    children,
    color = 'primary',
    iconRight = false,
    wrap = false
}) => {
    const th = useTheme()
    const iconColor = color ? th.colors[color] : 'inherit'

    const iconEl = (
        <Icon
            icon={icon}
            css={css`
                color: ${iconColor};
                font-size: ${th.iconToTextSizeRatio};
                ${iconRight
                    ? `margin-left: ${th.spacing.sm};`
                    : `margin-right: ${th.spacing.sm};`}
            `}
        />
    )

    return (
        <View
            horizontal
            css={css`
                justify-content: flex-start;
                ${wrap && 'flex-wrap: wrap;'}
            `}
        >
            {iconRight ? children : iconEl}
            {iconRight ? iconEl : children}
        </View>
    )
}
